import type { Campaign, CreativeAssignment, CreativeVersion } from "../api/types";

export interface CreativeAssignmentRow {
  campaignId: string;
  campaignName: string;
  campaignStatus: Campaign["status"] | "unknown";
  versionId: string;
  versionNumber: number | null;
  publicationState: CreativeVersion["publicationState"] | "unknown";
  weight: number;
  assignmentVersion: number;
  participatesInDelivery: boolean;
}

export function creativeAssignmentRows(
  assignments: CreativeAssignment[],
  versions: CreativeVersion[],
  campaigns: Campaign[] = [],
): CreativeAssignmentRow[] {
  const versionsById = new Map(versions.map(version => [version.id, version]));
  const campaignsById = new Map(campaigns.map(campaign => [campaign.id, campaign]));
  return assignments.map((assignment): CreativeAssignmentRow => {
    const version = versionsById.get(assignment.creativeVersionId);
    const campaign = campaignsById.get(assignment.campaignId);
    return {
      campaignId: assignment.campaignId,
      campaignName: campaign?.name ?? assignment.campaignId,
      campaignStatus: campaign?.status ?? "unknown",
      versionId: assignment.creativeVersionId,
      versionNumber: version?.version ?? null,
      publicationState: version?.publicationState ?? "unknown",
      weight: assignment.weight,
      assignmentVersion: assignment.assignmentVersion,
      participatesInDelivery: assignment.weight > 0 && campaign?.status === "active" && version?.publicationState === "published",
    };
  }).sort((left, right) => {
    if (left.participatesInDelivery !== right.participatesInDelivery) return left.participatesInDelivery ? -1 : 1;
    if (left.campaignName !== right.campaignName) return left.campaignName.localeCompare(right.campaignName, "ru");
    return (right.versionNumber ?? -1) - (left.versionNumber ?? -1);
  });
}
